import { render, staticRenderFns } from "./cookies.vue?vue&type=template&id=6ace8cf8&"
import script from "./cookies.ts?vue&type=script&lang=ts&"
export * from "./cookies.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports